import styled from '@emotion/styled';
export var LazyLoadFallback = styled.div({
  width: '100%',
  height: '100%'
});